import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

/**
 * Rechtstexte bekommen eigene Adressen -- die bewusste Ausnahme davon, dass
 * DREHRAUM sonst aus einer einzigen Seite besteht. Impressum und Datenschutz
 * muessen verlinkbar und direkt aufrufbar sein, ohne vorher durch die
 * Anwendung zu muessen.
 */
const routes: RouteRecordRaw[] = [
  /* Der Schreibtisch ist die Anwendung. Die einseitige Ansicht, die hier
     stand, liegt als Archiv unter `docs/archiv/einseitige-ansicht` -- sie
     wird nicht mehr gebaut und nicht mehr gepflegt, bleibt aber lesbar. */
  { path: '/', name: 'schreibtisch', component: () => import('@/views/SchreibtischView.vue') },
  { path: '/impressum', name: 'impressum', component: () => import('@/views/LegalView.vue') },
  { path: '/datenschutz', name: 'datenschutz', component: () => import('@/views/LegalView.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/' }
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 })
});
